import { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { KTSVG, toAbsoluteUrl } from "../../_metronic/helpers";
import { Button, InputGroup, FormControl } from 'react-bootstrap';
import { projects } from "../component/projectData";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
export const getComapnyByKey = (key) => {
    return projects.find(project => project.cname === key);
};
export const getComapnyBySecretKey = (secret_key) => {
    return projects.find(project => project.secret_key === secret_key);
};
export const getProjectByKey = (key) => {
    return projects.find(project => project.pkey === key);
};
export const getProjectByProject = (pname) => {
    return projects.find(project => project.pname === pname);
};
export const checkProjectTypeByLocal = () => {
    const dtype = localStorage.getItem('dtype')
    return dtype;
}
export const getProjectByLocal = () => {
    const pname = localStorage.getItem('company')

    return projects.find(project => project.pname === pname);
};
export const getProject = () => {
    const key = localStorage.getItem('pkey');
    return projects.find(project => project.pkey === key);
};
export const getProjectByCompany = () => {
    const key = localStorage.getItem('ckey');
    return projects.find(project => project.ckey === key);
};

/**
 * getProjectLoginUrl
 * @param {string} projectKey - The project key to get the login URL for
 * @returns {string} The login URL for the project
 */
export const getProjectLoginUrl = () => {
    const projectKey = localStorage.getItem('pkey');
    const companyKey = localStorage.getItem('ckey');
    if (companyKey || projectKey) {
        const company = projects.find(p => p.ckey === companyKey);
        const project = projects.find(p => p.pkey === projectKey);
        if (company?.login_screen) {
            return `/customer/${company.cname}/login`;
        } else if (project?.login_screen) {
            return `/customer/${project.cname}/login`;
        }
        return null;
    }
    return null
};

export const loginLogout = (response) => {
    console.log(response?.data?.message)
    if (response?.data?.message === "Unauthenticated.") {
        const loginUrl = getProjectLoginUrl()
        if (loginUrl) {
            clearStorage()
            window.location.href = loginUrl
        } else {
            clearStorage()
        }

    }
}
const clearStorage = () => {
    localStorage.removeItem('pkey');
    localStorage.removeItem('ckey');
    localStorage.removeItem('company');
    localStorage.removeItem('cuslogin');
    localStorage.removeItem('welcomePopup');
};
export const useProjectByStorage = () => {
    const [project, setProject] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const pkey = localStorage.getItem('pkey'); // Get the project key from local storage
        if (pkey) {
            const project = projects.find(project => project.pkey === pkey);
            if (!project) {
                // If the project is not found, logout the user
                loginLogout({ data: { message: "Unauthenticated." } });
            } else {
                setProject(project);
            }
        } else {
            // If no project key is found, handle logout
            //  handleLogout(null);
        }
    }, [navigate]);

    // Function to handle logout (redirect, clear storage, etc.)
    // const handleLogout = (project) => {
    //     localStorage.removeItem('pkey');
    //     localStorage.removeItem('cuslogin')
    //     navigate('/corteva/login'); 
    // };

    return project; // By default, return null if no valid project is found
};

export const useCompanyByStorage = () => {
    const [project, setProject] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const pkey = localStorage.getItem('pkey'); // Get the project key from local storage
        if (pkey) {
            const project = projects.find(project => project.pkey === pkey);
            if (!project) {
                // If the project is not found, logout the user
                //handleLogout(project);
            } else {
                setProject(project);
            }
        } else {
            const ckey = localStorage.getItem('ckey');
            if (ckey) {
                const project = projects.find(project => project.ckey === ckey);
                if (!project) {
                    // If the project is not found, logout the user
                    //handleLogout(project);
                } else {
                    setProject(project);
                }
            }
            // If no project key is found, handle logout
            //  handleLogout(null);
        }
    }, [navigate]);

    // Function to handle logout (redirect, clear storage, etc.)
    // const handleLogout = (project) => {
    //     localStorage.removeItem('pkey');
    //     localStorage.removeItem('cuslogin')
    //     navigate('/corteva/login'); 
    // };

    return project; // By default, return null if no valid project is found
};

export const RedemnessReady = ({ status }) => {
    return <div className="card mb-4 border rounded" style={{ backgroundColor: "#FBF6F7", border: "1px solid #FBF6F7" }}>
        <div className="card-body p-4">
            <div className='d-flex justify-content-between align-items-center'>
                <div className='fs-4 fw-semibolder text-dark'>
                    Your Redemption Readiness
                </div>
                {Number(status) === 1 ?
                    <i className="bi bi-check-circle-fill  text-success fs-2x"></i>
                    : <i className="bi bi-x-circle-fill text-danger fs-2x"></i>
                }
            </div>
        </div>
    </div>
}
export const VoucherHistoryCard = () => {
    return <div className="card mb-4 border rounded" style={{ backgroundColor: "#d86d72", border: "1px solid #FBF6F7" }}>
        <div className="card-body p-3">
            <div className="d-flex justify-content-between align-items-center">
                <div className='text-start d-flex align-items-center'>
                    <img style={{ width: '40px' }} className="me-4" src={toAbsoluteUrl('/media/images/voucher-gift.png')} alt="voucher" />
                    <div className='d-flex flex-column'>
                        <div className='fw-semibolder  text-white fs-3'>Voucher History </div>

                    </div>
                </div>
                <i className='fas fa-chevron-right fs-1 fw-semibolder text-white' style={{ color: "#6c757d" }}></i>
            </div>
        </div>
    </div>
}

export const WarningDisplay = ({ message }) => {
    return <div style={{ background: '#fefafa' }} className='card vh-100 mb-4'>
        <div className='card-body p-4'> <div className="notice d-flex bg-light-danger rounded border-primary border border-dashed mt-5 mb-9 p-6">
            <span className="svg-icon svg-icon-2tx svg-icon-primary me-4">
                <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-3x svg-icon-danger' />
            </span>
            <div className="d-flex flex-stack flex-grow-1">
                <div className="fw-semibold">
                    <div className="fs-6 text-gray-700 gap-3 ">{message}
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
}

export const CurrentRedemPoint = ({ dashboard }) => {
    return <div className="card p-2 mb-4 border rounded" style={{ backgroundColor: "#FBF6F7", border: "1px solid #FBF6F7" }}>
        <div className="card-body p-3">
            <div className='fw-semibolder fs-3'> Available Points: <span style={{ color: "#22A127" }} className="text-success fw-semibold">{dashboard?.totalBalance ? dashboard?.totalBalance : 0}</span></div>
        </div>
    </div>

}

export const HistoryCard = ({ card_title, card_text, backgroundColor, url, dashboard }) => {
    const navigate = useNavigate()
    return (

        <div
            className="card shadow-sm min-h-80px w-50"
            style={{ backgroundColor: "#fff", border: "1px solid #fff", cursor: "pointer" }}
            onClick={() => goToLink(navigate, url, dashboard)}
        >
            <div className="card-body p-2 d-flex justify-content-between align-items-center">
                <div className="text-start d-flex align-items-center">
                    <div className="d-flex flex-column">
                        <div className="fw-semibold text-dark">{card_title}</div>
                        <div className="fw-semibold" style={{ color: "#717171" }}>{card_text}</div>
                    </div>
                </div>
                <div className='symbol symbol-20px  symbol-circle '  >
                    <span className="symbol-label fs-6 fw-semibold text-white " style={{ backgroundColor: backgroundColor }}>
                        <i className="fas fa-chevron-right   text-white"></i>
                    </span>
                </div>
            </div>
        </div>

    );
}
export const CategoryCard = ({ item }) => {

    return (
        <div className='card bg-white' style={{ minHeight: '107px', border: "1px solid #eaeaea" }} >
            <div className='card-body p-5 py-4 '>
                <div className="d-flex justify-content-between align-items-center">
                    <img style={{ width: '32px' }} className="me-4" src={item?.image_url ? item?.image_url : toAbsoluteUrl('/media/images/re-gift.png')} alt="re-gift" />
                    <i className="fas fa-chevron-right   text-gray-700"></i>
                </div>
                <div className="pt-4 fs-6 fw-semibolder text-capitalize">{item?.CatName}{item?.subCatName}</div>
            </div>
        </div>

    );
}

export const HeaderCartIcon = ({ count }) => {

    return (
        <Link to="/customer/redem-cart">
            <div

                className="d-flex align-items-center gap-3 mx-2 px-2"
                style={{
                    border: "1px solid #eaeaea",
                    borderRadius: "24px",
                    width: "115px",
                    height: "42px",
                    backgroundColor: count > 0 ? "#1E9A0B" : "#8F8F8F" // Bootstrap colors
                }}

            >
                <div className="symbol symbol-30px symbol-circle">
                    <span className="symbol-label bg-white d-flex align-items-center justify-content-center p-0">
                        <i className="bi bi-cart-fill text-dark fs-4"></i>
                    </span>
                </div>
                <div className="d-flex flex-column text-white" style={{ lineHeight: '1.2' }}>
                    <span className="fs-8 fw-semibold">Your Cart :</span>
                    <span className="fs-7 fw-semibolder">{count}</span>
                </div>
            </div>
        </Link>


    );
}

export const HistoryItemCard = ({ data, url = null }) => {
    const navigate = useNavigate()
    return (
        <div className="card p-3 mt-2" style={{ border: '1px solid #eaeaea' }} onClick={() => url && navigate(url)}>
            <div className="d-flex  ">
                {/* Left Section: Image */}

                <img
                    src={data?.image_url ?? toAbsoluteUrl('/media/logos/blank-big.jpg')}
                    alt="blank"
                    className="img-fluid h-75px  rounded me-4 w-25 "

                />


                {/* Middle Section: Details */}
                <div className="flex-grow-1">
                    <div className=" fs-6   rounded">{data?.sku_name}</div>

                    <div className="">
                        Status - <span className="fw-semibold" style={{ color: "#31A835" }}>{data?.status}</span>
                    </div>
                    <div className="">
                        Sub Order ID:  <span className="fw-semibolder">{data?.sub_order_id}</span>
                    </div>
                </div>

                {/* Right Section: Icon */}
                <div className="d-flex align-items-center ">
                    <i className="fas fa-chevron-right  fw-semibolder text-dark" ></i>
                </div>
            </div>
        </div>
    );
};

export const ItemDetailCard = ({ data, url = null }) => {
    const navigate = useNavigate()
    return (
        <div className="card p-3" style={{ border: '1px solid #eaeaea' }} onClick={() => url && navigate(url)}>
            <div className="d-flex">
                {/* Left Section: Image */}

                <img
                    src={data?.image_url ?? toAbsoluteUrl('/media/logos/blank-big.jpg')}
                    alt="blank"
                    className="img-fluid h-100px  rounded me-4 w-100px "

                />


                {/* Middle Section: Details */}
                <div className="d-flex  flex-column gap-1">
                    <div className="fw-semibold fs-6   rounded">{data?.sku_name}</div>
                    <div className="d-flex justify-content-between">
                        <div> <span className="fw-semibolder text-danger">{data?.redemed_point} Pts</span></div>
                        {data?.quantity &&
                            <div> Quantity: <span className="fw-semibolder text-danger pe-6">{data?.quantity}</span></div>
                        }
                    </div>
                    {data?.status &&
                        <div className="">
                            Status - <span className="fw-semibold" style={{ color: "#31A835" }}>{data?.status}</span>
                        </div>
                    }
                    {data?.total_used_points &&
                        <div className="">
                            Total Used Points:  <span className="fw-semibolder">{data?.total_used_points} Pts</span>
                        </div>
                    }
                    {data?.sub_order_id &&
                        <div className="">
                            Sub Order ID:  <span className="fw-semibolder">{data?.sub_order_id}</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};



export const BalancePointCard = ({ totalBalance, points, qty }) => {
    const totalPoints = points * qty

    return (
        <BalanceCard totalBalance={totalBalance} totalPoints={totalPoints} />
    );
};

export const CartNoticeHelper = ({ gift_type }) => {
    return <div className="border rounded  mt-2" >
        <div className="px-3 py-2 fw-semibold rounded-top fs-5 fw-semibold" style={{ backgroundColor: "#ECECEC" }}>Note:</div>
        <div className="bg-white p-3 py-2 rounded-bottom ">
            <p className="fs-6">
                {(Number(gift_type) === 1 || Number(gift_type) === 6) &&
                    <>Your redem item  will be this address. Visit the Redemption History page after redeeming to track the status.</>
                }
                {Number(gift_type) === 2 &&
                    <>Your DBT will be credited to the account shown above. Visit the Redemption History page after redeeming to track the status.</>
                }
                {Number(gift_type) === 3 &&
                    <> Your voucher details will be available in the Redeemed Vouchers section on the Redemption Home page.</>
                }
            </p>
        </div>
    </div>
}
export const BalanceCard = ({ totalBalance, totalPoints }) => {
    const afterBalance = totalBalance - totalPoints
    return (
        <div className="card p-3" style={{ border: '1px solid #eaeaea' }} >

            <div className="d-flex justify-content-between">
                <div className="text-dark fw-semibold fs-6">Available Points</div>
                <div className="fw-semibold fs-6">{totalBalance} Points</div>
            </div>
            <div className="d-flex justify-content-between">
                <div className="text-dark fw-semibold fs-6">This Redemption</div>
                <div className="fw-semibold fs-6" style={{ color: "#CB171A" }}>{totalPoints} Points</div>
            </div>
            <div className="d-flex justify-content-between">
                <div className="text-dark fw-semibold fs-6">Balance After Redemption</div>
                <div className=" fw-semibold fs-6" style={{ color: "#22A127" }}>{afterBalance} Points</div>
            </div>
        </div>
    );

}

export const SelectedAddress = ({ address }) => {

    return <div className="card p-3 mt-4" style={{ border: '1px solid #eaeaea' }}>
        <div className="fw-semibold fs-5 mb-2">Delivery Address</div>
        <div className="d-flex align-items-start  ">
            <i className="bi-geo-alt-fill fs-1 me-1 mt-1 text-danger"></i>
            <div className='fs-6 mt-1'>
                <p className="fw-semibold fs-6">
                    {address?.address1 && `${address.address1} ,`}
                    {address?.address2 && `${address.address2} ,`}
                    {address?.address3 && `${address.address3} ,`}
                    {address?.landmark && `${address.landmark} ,`}
                    {address?.city && `${address.city} ,`}
                    {address?.district && `${address.district} ,`}
                    {address?.state && `${address.state} ,`}
                    {address?.pincode && `${address.pincode}`}
                </p>
            </div>
        </div>
    </div>
}

export const QuantityInput = ({ quantity, changeQuantity, totalBalance, points, error, setError }) => {
    const handleIncrement = () => {
        if (parseInt(totalBalance) < (parseInt(points) * quantity) || (totalBalance - (parseInt(points) * quantity)) === 0) {
            setError('You are trying to add a quantity that exceeds your available balance.')
        } else {

            changeQuantity(quantity + 1);
        }

    };


    const handleDecrement = () => {
        if (quantity > 1) {
            setError(null)
            changeQuantity(quantity - 1);
        }
    };

    const handleChange = (e) => {
        const value = parseInt(e.target.value, 10);
        if (!isNaN(value) && value >= 1) {
            if (parseInt(totalBalance) < (parseInt(points) * value)) {
                setError('You are trying to add a quantity that exceeds your available balance.')
            } else {
                setError(null)
                changeQuantity(value)
            }
        }
    };

    return (
        <div className="border w-100 rounded">
            <InputGroup className="border-1 rounded">
                <Button className="fs-2 text-dark" variant="outline-secondary" onClick={handleDecrement}>-</Button>
                <FormControl
                    value={quantity}
                    onChange={handleChange}
                    type="number"
                    min="1"
                    aria-label="Quantity"
                    className="form-control-solid fs-5 text-center"
                />
                <Button disabled={error} className="fs-2 text-dark" variant="outline-secondary " onClick={handleIncrement}>+</Button>
            </InputGroup>
        </div>
    );
}



export const goToLink = (navigate, target, data) => {
    navigate(target, { state: data });
}

export const ShowError = ({ error, closePopup }) => {

    return <div className="card-body text-center">
        <div className="row">
            <div className="col-md-12 pancard-data">
                <div className="text-center mb-7">
                    <img
                        width="50"
                        alt="icon"
                        src={toAbsoluteUrl("/media/images/cancel.png")}
                    />
                    <h3 className="text-danger">Error!</h3>
                </div>
            </div>
        </div>

        <div className="notice d-flex bg-light-danger rounded border-danger border border-dashed p-2 mb-4">
            <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-3x svg-icon-danger me-5' />

            <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                <div className=" mb-md-0 fw-semibold">

                    <div className="fs-7 text-gray-700 pe-7">
                        {error}
                    </div>

                </div>

            </div>
        </div>

        <div className="d-flex mt-10 flex-column align-item-center text-bold"> <button onClick={() => closePopup()} className="btn btn-lg text-white bg-dark">Close</button></div>
    </div>
}

export const ShowSuccess = ({ success, closePopup }) => {



    return <div className="card-body text-center">
        <div className="row">
            <div className="col-md-12 pancard-data">
                <div className="text-center  mb-7">
                    <img
                        width=""
                        alt="icon"
                        src={toAbsoluteUrl("/media/images/checked1.png")}
                    />

                </div>
            </div>
        </div>

        <div className="notice d-flex bg-light-success rounded border-success border border-dashed p-2 mb-4">
            <KTSVG path='/media/icons/duotune/general/gen045.svg' className='svg-icon-3x svg-icon-success me-5' />

            <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                <div className=" mb-md-0 fw-semibold">

                    <div className="fs-7 text-gray-700 pe-7">
                        {success}
                    </div>

                </div>

            </div>
        </div>

        <div className="d-flex mt-10 flex-column align-item-center text-bold"> <button onClick={() => closePopup()} className="btn btn-lg text-white bg-dark">Close</button></div>
    </div>
}


export const NewShowError = ({ title = "Error!", error, closePopup }) => {

    return <div className="bg-white d-flex flex-column  w-100 p-4" style={{ maxWidth: "800px" }}>
        <div className='d-flex justify-content-center w-100'>
            <img width="220" alt="icon" src={"/media/images/error11.png"} className="mb-4" />
        </div>
        <h2 className="mb-3 text-danger">{title}</h2>
        <p className="text-gray-600"> {error}</p>

        <div className="d-flex mt-10 flex-column align-item-center text-bold"> <button onClick={() => closePopup()} className="btn btn-lg text-white bg-dark">OK</button></div>
    </div>
}

export const NewShowSuccess = ({ title = "Successfully", success, closePopup }) => {

    return <div className="bg-white d-flex flex-column  w-100 p-4" style={{ maxWidth: "800px" }}>
        <div className='d-flex justify-content-center w-100'>
            <img width="220" alt="icon" src={"/media/images/new-success.png"} className="mb-4" />
        </div>
        <h2 className="mb-3 ">{title}</h2>
        <p className="text-gray-600"> {success}</p>

        <div className="d-flex mt-10 flex-column align-item-center text-bold"> <button onClick={() => closePopup()} className="btn btn-lg text-white bg-dark">OK</button></div>
    </div>
}


export const SchemeCard = ({ project }) => {
    return (
        <div className='card  border  border-2  cursor-pointer' >
            <img
                className="card-img-top p-3"
                src={toAbsoluteUrl(project?.scheme_banner)}
                alt={project?.pname}
                style={{
                    width: '100%',
                }}
            />
            <div className='d-flex justify-content-between p-2 mx-2'>
                <div className="text-dark fs-4 fw-semibold">{project?.project_text}</div>
                <div className="symbol symbol-20px symbol-circle">
                    <span className="symbol-label fs-6 fw-semibold text-white" style={{ backgroundColor: "black" }}>
                        <i className="fas fa-chevron-right text-white"></i>
                    </span>
                </div>
            </div>
        </div>
    )
}


export const SpecialFiltter = ({ cat_slug = null }) => {
    const navigate = useNavigate();
    const handleClick = () => {
        const url = cat_slug ? `/customer/redemption-cat-center/${cat_slug}` : '/customer/redemption-center';
        goToLink(navigate, url, []);
    };
    return <>
        <div className='col-6 mb-4'>
            <div className='card bg-white' onClick={handleClick} style={{ minHeight: '107px', border: "1px solid #eaeaea" }} >
                <div className='card-body p-5 py-4 '>
                    <div className="d-flex justify-content-between align-items-center">
                        <img style={{ width: '32px' }} className="me-4" src={toAbsoluteUrl('/media/images/box.png')} alt="box" />
                        <i className="fas fa-chevron-right   text-gray-700"></i>
                    </div>
                    <div className="pt-4 fs-6 fw-semibolder text-capitalize">Show All</div>
                </div>
            </div>
        </div >
        <div className='col-6 mb-4'>
            <div className='card bg-white' onClick={() => goToLink(navigate, `/customer/redemption-offer`, [])} style={{ minHeight: '107px', border: "1px solid #eaeaea" }} >
                <div className='card-body p-5 py-4 '>
                    <div className="d-flex justify-content-between align-items-center">
                        <img style={{ width: '32px' }} className="me-4" src={toAbsoluteUrl('/media/images/percentage.png')} alt="percentage" />
                        <i className="fas fa-chevron-right   text-gray-700"></i>
                    </div>
                    <div className="pt-4 fs-6 fw-semibolder text-capitalize">Current Offers</div>
                </div>
            </div>
        </div>
    </>
}


export const RedemnessStatus = ({ dashboard }) => {
    return (
        <>
            {(() => {
                const kyc = dashboard?.kyc ?? {};
                const bankStatus = dashboard?.bankStatus;
                const upiStatus = dashboard?.upiStatus;
                const panStatus = dashboard?.panStatus;

                // Helper to determine status state (reduces Number()/String() usage)
                const isStatusApproved = status => String(status) === "1";
                const isStatusRejected = status => String(status) === "0";
                const isStatusNull = status => status === null;

                // Info definition array
                const items = [
                    {
                        show: String(kyc.bank) === "1",
                        icon: "/media/images/bank.png",
                        label: "Bank Details",
                        status: bankStatus
                    },
                    {
                        show: String(kyc.upi) === "1",
                        icon: "/media/images/upi.png",
                        label: "UPI Detail ",
                        status: upiStatus
                    },
                    {
                        show: String(kyc.pan) === "1",
                        icon: "/media/images/pan-card.png",
                        label: "PAN Card",
                        status: panStatus
                    }
                ];

                return items.map(
                    ({ show, icon, label, status }, idx) =>
                        show && (
                            <div className="row user_doc mt-4" key={label}>
                                <div className="col-md-12">
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            isStatusApproved(status) ? (
                                                <Tooltip id={`tooltip-${label.replace(/\s+/g, '').toLowerCase()}-verified`}>Verified by Admin</Tooltip>
                                            ) : isStatusRejected(status) ? (
                                                <Tooltip id={`tooltip-${label.replace(/\s+/g, '').toLowerCase()}-not-verified`}>Rejected by Admin</Tooltip>
                                            ) : (
                                                <Tooltip id={`tooltip-${label.replace(/\s+/g, '').toLowerCase()}-pending`}>
                                                    {isStatusNull(status)
                                                        ? 'Verification Inprogress'
                                                        : "No Record Found"
                                                    }
                                                </Tooltip>
                                            )
                                        }
                                    >
                                        <div className="d-flex align-items-center justify-content-between doc_outer">
                                            <div className="user_info d-flex align-items-center">
                                                <div className="icon_box bgdark-blue">
                                                    <img
                                                        width="20"
                                                        alt="icon"
                                                        src={toAbsoluteUrl(icon)}
                                                    />
                                                </div>
                                                <h6 className="px-3 fs-4 mb-0">{label}</h6>
                                            </div>
                                            {isStatusApproved(status) ? (
                                                <i className="bi bi-patch-check-fill fs-3 text-success ms-2"></i>
                                            ) : isStatusRejected(status) ? (
                                                <i className="bi bi-x-circle-fill fs-4 red-cross"></i>
                                            ) : (
                                                <>
                                                    {isStatusNull(status) ? (
                                                        <i className="bi text-warning fs-4 bi-exclamation-triangle fs-4"></i>
                                                    ) : (
                                                        <i className="bi fs-4 bi-check-circle-fill"></i>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        )
                );
            })()}
        </>
    )
}